import * as React from "react";
import ScrollBar from "react-perfect-scrollbar";
import { connect } from "react-redux";
import { selectPoolRewardsIconInfo } from "../../balancingSelectors/selectBalancingRandomPools";
import { ScrollOptions } from "../../constants/ScrollOptions";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { DialogWrapper } from "../dialog/DialogWrapper";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { ListPictureRewards } from "./ListPictureRewards";
import { ListResourceRewards } from "./ListResourceRewards";
var _DialogShowAllRewardsStore = function (_a) {
    var onClose = _a.onClose, packageInfo = _a.packageInfo;
    if (packageInfo == undefined || packageInfo.balancing.randomPoolReward == undefined) {
        return React.createElement(React.Fragment, null);
    }
    var chestRewards = selectPoolRewardsIconInfo(packageInfo.balancing.randomPoolReward[0].randomPoolId);
    var isPictureReward = chestRewards[0].loca == undefined;
    var rewardList = isPictureReward ? (React.createElement(ListPictureRewards, { items: chestRewards })) : (React.createElement(ListResourceRewards, { items: chestRewards }));
    return (React.createElement(DialogWrapper, { titleLocaId: IdLoca.possibleRewards, onClose: onClose, className: IdStyles.ModalBackgroundResources },
        React.createElement(ScrollBar, { component: "div", options: ScrollOptions, className: "w100" }, rewardList)));
};
var mapState = function (state) { return ({
    packageInfo: state.storeInfo.package,
}); };
var mapDispatch = function (dispatch) { return ({
    onClose: function () { return dispatch(actionModalClose(IdModal.ShowAllRewardsStore)); },
}); };
export var DialogShowAllRewardsStore = connect(mapState, mapDispatch)(_DialogShowAllRewardsStore);



//////////////////
// WEBPACK FOOTER
// ./src/features/store/DialogShowAllRewardsStore.tsx
// module id = 2929
// module chunks = 3